import React, { ReactNode } from "react";
import { FieldProps, useFormikContext } from "formik";
import OTPInput from "react-otp-input";
import "./OTPField.scss";

export type OTPInputProps = {
  value: number | string;
  onChange: any;
  numInputs: number;
  separator?: JSX.Element | undefined;
  isDisabled?: boolean | undefined;
  shouldAutoFocus?: boolean | undefined;
  hasErrored?: boolean | undefined;
  isInputNum?: boolean | undefined;
  containerStyle?: string | React.CSSProperties | undefined;
  inputStyle?: string | React.CSSProperties | undefined;
  focusStyle?: string | React.CSSProperties | undefined;
  disabledStyle?: string | React.CSSProperties | undefined;
  errorStyle?: string | React.CSSProperties | undefined;
  renderInput: (props: any) => ReactNode;
  placeholder?: string;
  inputType?: "text" | "password";
};

const OTPField: React.FC<FieldProps & OTPInputProps> = ({
  renderInput,
  placeholder,
  value,
  onChange,
  numInputs,
  shouldAutoFocus,
  field,
  form,
  // meta,
  ...props
}) => {
  const { setFieldValue, errors, touched, dirty, getFieldMeta } =
    useFormikContext<any>();

  const meta = getFieldMeta(field.name);

  console.log("Errors: \n" + field.name + "\n", meta);

  return (
    <>
      {/* <OTPInput
        renderInput={(props: any) => <input {...props} />}
        numInputs={numInputs}
        inputType="password"
        inputStyle={`otp ${
          touched[field.name] && errors[field.name] ? "error-state" : ""
        }${!!meta['value'] && "touched"}`}
        containerStyle="otp-container"
        {...props}
        {...field}
        onChange={(val) => {
          setFieldValue(field.name, val);
        }}
      /> */}

      <OTPInput
        renderInput={(inputProps: any, index: number) => (
          <input
            {...inputProps}
            onKeyDown={(e) => {
              const allowedKeys = [
                "Backspace",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
                "Tab",
              ];
              const isNumber = /^\d$/.test(e.key);

              // Allow only numbers and navigation
              if (!isNumber && !allowedKeys.includes(e.key)) {
                e.preventDefault();
              }

              // Handle Backspace to move focus back
              if (e.key === "Backspace" && !inputProps.value) {
                const prevInput = document.querySelectorAll("input")[
                  index - 1
                ] as HTMLInputElement;
                if (prevInput) {
                  prevInput.focus();
                  prevInput.value = "";
                  e.preventDefault();
                }
              }
            }}
          />
        )}
        numInputs={numInputs}
        isInputNum={true}
        inputType="password"
        inputStyle={`otp ${
          touched[field.name] && errors[field.name] ? "error-state" : ""
        }${!!meta["value"] && "touched"}`}
        containerStyle="otp-container"
        {...props}
        {...field}
        onChange={(val) => {
          setFieldValue(field.name, val);
        }}
      />

      {dirty &&
        meta["value"] &&
        (meta["value"] as unknown as string)?.length === numInputs &&
        meta["error"] && (
          <div className="error">
            <>{meta["error"]}</>
          </div>
        )}
    </>
  );
};

export default OTPField;
